import { useDispatch, useSelector } from "react-redux";
import { login as loginAction, logout as logoutAction } from "./actions";

const useAuthContext = () => {
	const dispatch = useDispatch();

	const useIsAuthenticated = () =>
		useSelector((state) => state.authentication.isAuthenticated);

	const useProfile = () => useSelector((state) => state.authentication.profile);

	const useIsLoading = () =>
		useSelector((state) => state.authentication.isLoading);

	const useIsSuperUser = () =>
		useSelector((state) => {
			const { su } = state.authentication.profile || {};
			return su === "1";
		});

	const state = {
		isLoading: useIsLoading,
		profile: useProfile,
		isAuthenticated: useIsAuthenticated,
		isSuperUser: useIsSuperUser
	};

	const login = (credentials) => {
		return loginAction(credentials, dispatch);
	};

	const logout = () => {
		logoutAction(dispatch);
	};

	return { state, login, logout };
};

export { useAuthContext };
